import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObjectSplitByVendor } from 'util/data';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';


const
    name = 'itcProducts',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.itcProducts.endpoint,
        instanceEndpoint:   endpoints.itcProducts.instanceEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: json => transformResultsFromObjectSplitByVendor(json.results, 'ITCONIC')
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/itcProducts.js